import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=048ca42c&scoped=true&lang=pug&"
import script from "./Menu.vue?vue&type=script&lang=coffee&"
export * from "./Menu.vue?vue&type=script&lang=coffee&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=048ca42c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "048ca42c",
  null
  
)

export default component.exports